import { Button } from '@/components';
import { SingleDateDropdown } from '@/components/SingleDateDropdown/SingleDateDropdown';
import { useUpdateAutomationInfrastructureCost } from '@/modules/Automations/queries/use-update-automation-infrastructure-cost';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type EditAutomationCostFormProps = {
  automationId: number;
  infrastructureCostId: number;
  defaultValues: {
    startDate?: Date;
    endDate?: Date;
  };
  onCancel: () => void;
  onSubmit: () => void;
};

export const EditAutomationCostForm = ({
  automationId,
  infrastructureCostId,
  defaultValues,
  onCancel,
  onSubmit,
}: EditAutomationCostFormProps) => {
  const [startDate, setStartDate] = useState(defaultValues.startDate);
  const [endDate, setEndDate] = useState(defaultValues.endDate);
  const { t } = useTranslation();
  const {
    mutate: updateAutomationInfrastructureCost,
    isLoading: isSubmitting,
  } = useUpdateAutomationInfrastructureCost();

  return (
    <form
      className="flex flex-col gap-2"
      onSubmit={(e) => {
        e.preventDefault();
        updateAutomationInfrastructureCost({
          automationId,
          infrastructureCostId,
          startDate,
          endDate,
        });
        onSubmit();
      }}
    >
      <div className="flex flex-col gap-2">
        <div className="text-sm font-bold">
          {t('start_date')}
          <span className="font-medium">({t('date_applied_automation')})</span>
        </div>
        <SingleDateDropdown
          placeholder={t('select_date')}
          onChange={setStartDate}
          date={startDate}
          className="h-10 w-full rounded-md bg-brightGray p-2 text-md capitalize italic"
        />
      </div>
      <div className="flex flex-col gap-2">
        <div className="text-sm font-bold">
          {t('end_date')}
          <span className="font-medium">
            ({t('date_not_applied_automation')})
          </span>
        </div>
        <SingleDateDropdown
          placeholder={t('select_date')}
          onChange={setEndDate}
          date={endDate}
          className="h-10 w-full rounded-md bg-brightGray p-2 text-md capitalize italic"
        />
      </div>
      <div className="mt-8 flex justify-between">
        <Button
          isDisabled={isSubmitting}
          onClick={onCancel}
          variant="outline"
          className="h-9 w-24"
        >
          {t('cancel')}
        </Button>
        <Button
          isDisabled={isSubmitting}
          buttonType="submit"
          className="h-9 w-24"
        >
          {t('attach')}
        </Button>
      </div>
    </form>
  );
};
